const Analytics = () => (
    <svg
        width='34'
        height='35'
        viewBox='0 0 34 35'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g>
            <path
                d='M15.6088 34.3031C24.2041 34.3031 31.216 27.2912 31.216 18.6959V18.5599C31.216 17.7912 30.6275 17.2027 29.8588 17.2027L17.1003 17.2045V4.44601C17.1003 3.67732 16.5119 3.08887 15.7432 3.08887H15.6071C7.0119 3.08887 0 10.1008 0 18.696C0.001767 27.2912 7.01371 34.3031 15.6089 34.3031L15.6088 34.3031ZM14.386 5.84924V18.562C14.386 19.3307 14.9745 19.9192 15.7432 19.9192H28.456C27.8233 26.4787 22.3027 31.591 15.6092 31.591C8.50733 31.591 2.7164 25.8001 2.7164 18.6982C2.7164 12.0025 7.87263 6.48212 14.3865 5.84969L14.386 5.84924Z'
                fill='url(#paint0_linear_1001_3553)'
            />
            <path
                d='M20.449 0.466382C20.0426 0.420439 19.6803 0.512326 19.364 0.782696C19.0477 1.05483 18.9116 1.41531 18.9116 1.82353V14.0378C18.9116 14.8065 19.5001 15.395 20.2688 15.395H32.483C32.8895 15.395 33.2517 15.2147 33.5239 14.9426C33.796 14.6263 33.8861 14.264 33.8402 13.8576L33.7942 13.6773C32.7994 6.89163 27.3709 1.46306 20.5852 0.468273L20.449 0.466382ZM21.6241 3.45105C26.102 4.62797 29.677 8.20105 30.8518 12.6787L21.6241 12.6805V3.45105Z'
                fill='url(#paint1_linear_1001_3553)'
            />
        </g>
        <defs>
            <linearGradient
                id='paint0_linear_1001_3553'
                x1='0'
                y1='18.696'
                x2='31.216'
                y2='18.696'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_1001_3553'
                x1='18.9116'
                y1='7.92501'
                x2='33.8516'
                y2='7.92501'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00FFFF' />
            </linearGradient>
        </defs>
    </svg>
);

export default Analytics;
